import NavBar from "../NavBar/NavBar";
import Banner from "../Banner/Banner";
import { getEnvironmentFromBackendUrl } from "../../utils/utils";
import PropTypes from 'prop-types';

const MainLayout = ({ children, mainSx = {} }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        margin: 0,
      }}
    >
      <NavBar />
      <div
        style={{
          display: "flex",
          flex: 1,
          overflowY: "auto",
          ...mainSx,
        }}
      >
        {children}
      </div>
      {/* <Footer /> */}
      {getEnvironmentFromBackendUrl(process.env.REACT_APP_BACKEND_URL) !== "prod" && <Banner />}
    </div>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  mainSx: PropTypes.object,
};

export default MainLayout;
